import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2 } from 'lucide-react';
const deliverables = ['Guía Paso a Paso del Protocolo Flash (48 Horas)', 'El Mapa de Comidas del Sábado (Preparación) y Domingo (Reset)', 'La Fórmula ALV (Agua-Limón-Vinagre) para despertar el metabolismo', 'Checklist SOS de Compra de Supermercado', 'Guía del "Café Metabólico" para energía sin hinchazón'];
export function WhatYouGet() {
  return <section className="py-16 md:py-24 px-6 bg-sage/5" data-id="element-261">
      <div className="max-w-3xl mx-auto" data-id="element-262">
        <FadeIn data-id="element-263">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-charcoal" data-id="element-264">
            Todo lo que incluye tu Protocolo Flash
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-265">
          {deliverables.map((item, index) => <FadeIn key={index} delay={index * 0.1} direction="left" data-id="element-266">
              <div className="flex items-center gap-4 p-5 md:p-6 bg-white rounded-xl shadow-sm border border-sage/10" data-id="element-267">
                <div className="flex-shrink-0" data-id="element-268">
                  <CheckCircle2 className="w-6 h-6 text-sage" data-id="element-269" />
                </div>
                <span className="text-lg text-charcoal font-medium" data-id="element-270">
                  {item}
                </span>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}